import { Routes } from '@angular/router';
import { BuyRequestDetailsComponent } from './buy-request-details/buy-request-details.component';
import { LeaseRequestDetailsComponent } from './lease-request-details/lease-request-details.component';
import { OneWayDetailsComponent } from './one-way-details/one-way-details.component';
import { RequestPageComponent } from './request-page/request-page.component';
import { AuthGuard } from "../../guards/auth.guard";
import { LeadSubmitComponent } from './lead-submit/lead-submit.component';
import { QuoteAcceptanceComponent } from './quote-acceptance/quote-acceptance.component';
import { BlankLeadComponent } from './blank-lead/blank-lead.component';

export const WebRequestRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: RequestPageComponent,
        pathMatch: 'full',
      },
      {
        path: 'lead-request',
        component: LeadSubmitComponent,
        // canActivate: [AuthGuard],
      },
      {
        path: 'lead-request/one-way-details',
        component: OneWayDetailsComponent,

        canActivate: [AuthGuard],
      },
      {
        path: 'lead-request/trading-details',
        component: BuyRequestDetailsComponent,
        canActivate: [AuthGuard],

      },
      {
        path: 'lead-request/lease-details',
        component: LeaseRequestDetailsComponent,

        canActivate: [AuthGuard],
      },
      {
        path: 'quote-acceptance',
        component: QuoteAcceptanceComponent,

      },
      {
        path: 'lead-request-create',
        component: BlankLeadComponent,

      }
    ]
  }
]

